var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_10676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37547 24.7852H5.27391V11.543H9.37547V24.7852ZM9.78469 7.32398C9.78469 5.99807 8.70891 4.92188 7.38375 4.92188C6.05344 4.92188 4.98047 5.99807 4.98047 7.32398C4.98047 8.65037 6.0535 9.72656 7.38375 9.72656C8.70896 9.72656 9.78469 8.65037 9.78469 7.32398ZM24.7266 17.4998C24.7266 13.9451 23.9756 11.3086 19.823 11.3086C17.8276 11.3086 16.4882 12.3065 15.9414 13.3443H15.9375V11.543H11.9531V24.7852H15.9375V18.2104C15.9375 16.4884 16.3758 14.8204 18.5101 14.8204C20.6154 14.8204 20.6836 16.7894 20.6836 18.3197V24.7852H24.7266V17.4998ZM30 26.4844V3.51562C30 1.57699 28.423 0 26.4844 0H3.51562C1.57699 0 0 1.57699 0 3.51562V26.4844C0 28.423 1.57699 30 3.51562 30H26.4844C28.423 30 30 28.423 30 26.4844ZM26.4844 2.34375C27.1305 2.34375 27.6562 2.86951 27.6562 3.51562V26.4844C27.6562 27.1305 27.1305 27.6562 26.4844 27.6562H3.51562C2.86951 27.6562 2.34375 27.1305 2.34375 26.4844V3.51562C2.34375 2.86951 2.86951 2.34375 3.51562 2.34375H26.4844Z",
    fill: "#AE8FD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_10676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinHome);
export default __webpack_public_path__ + "static/media/Linkedin-home.7840b350f31009c525354117364e389c.svg";
export { ForwardRef as ReactComponent };